export const handleDownload = async (fileUrl, fileName = "downloaded_file") => {
    if (!fileUrl) {
      alert("File URL is missing.");
      return;
    }
  
    try {
      const response = await fetch(fileUrl, { mode: "cors" }); // Ensure CORS
      if (!response.ok) throw new Error("File not found or access denied");
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || fileUrl.split("/").pop(); // Use actual filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Failed to download file. Please try again.");
      console.error("Download error:", error);
    }
  };  